/**
 * Extracts the `uidb64` and `token` parameters from a given pathname.
 
 * @param {string} pathname - The URL pathname to extract parameters from.
 * @returns {{ uidb64: string, token: string }} An object containing:
 * - `uidb64`: A Base64-encoded user identifier extracted from the third segment of the pathname.
 * - `token`: A token extracted from the fourth segment of the pathname.
 */

export function getURLParams(pathname: string) {
  const URLParams = pathname.split('/');

  if (URLParams.length === 4) {
    return {
      uidb64: URLParams[2],
      token: URLParams[3],
    };
  }

  return {
    uidb64: '',
    token: '',
  };
}
